<template>
  <div class="containter">
    <div class="h-bg">
      <div class="header-box">
        <div class="header-box-left">
          <div class="top-time">
            <el-image style="width: 26px; height: 25px;margin-right: 9px"
                      :src="require('@/assets/images/header/dateTime.png')" fit="cover"></el-image>
            <div>
              <div class="f11">{{ nowTimeDay }}</div>
              <div class="f16" style="letter-spacing:2px">{{ nowTimeSecond }}</div>
            </div>
          </div>
          <el-button class="top-btn" @click="goto('/park/EnterpriseStatisticalAnalysis')"
                     :class="['btn-item',{'active':headerBtn==='/park/EnterpriseStatisticalAnalysis'}]">园区企业分析
          </el-button>
          <el-button class="top-btn" @click="goto('/park/EnterpriseValueAnalysis')"
                     :class="['btn-item',{'active':headerBtn==='/park/EnterpriseValueAnalysis'}]">企业价值分析
          </el-button>
        </div>
        <div class="title f40">园区科技成果大数据分析系统</div>
        <div class="header-box-right">
          <el-button class="top-btn" @click="goto('/park/PatentStatisticalAnalysis')"
                     :class="['btn-item',{'active':headerBtn==='/park/PatentStatisticalAnalysis'}]">专利统计分析
          </el-button>
          <el-button class="top-btn" @click="goto('/park/PatentValueAnalysis')"
                     :class="['btn-item',{'active':headerBtn==='/park/PatentValueAnalysis'}]">专利价值分析
          </el-button>
          <el-select v-model="parkId" style="width: 160px; height: 34px; margin-left: auto" @change="setCurrentPark">
            <el-option v-for="i in parkList" :value="i.id" :label="i.name" :key="i.id"></el-option>
          </el-select>
          <div @click="fullScreen" class="fullbtn">
<!--            <template v-if="isFullscreen">-->
<!--              <img src="@/assets/images/header/outfull.png" alt="">退出全屏-->
<!--            </template>-->
<!--            <template v-else>-->
<!--              <img src="@/assets/images/header/infull.png" alt="">全屏显示-->
<!--            </template>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapGetters, mapActions} from "vuex";
import Search from '@/components/common/search.vue'
import {storePersistKey} from "@/plugins/tools/Constant";
import {errorToast, successToast} from "@/plugins/tools/util";
import screenfull from "screenfull/dist/screenfull"

export default {
  props: [],
  watch: {
    $route: {
      immediate: true, // 一旦监听到路由的变化立即执行
      // 深度观察监听
      deep: true,
      handler(to, from) {
        console.log('to', to)
        const path = to.path
        this.headerBtn = '/' + path.split('/')[1] + '/' + path.split('/')[2]

      },
    }
  },
  components: {
     Search
  },
  computed: {
    ...mapGetters({
      current_site:'current_site',
      permissions: 'permissions'
    }),
  },
  inject: ["reload", "msg"],
  mounted() {
    this.getNowTime()
    clearInterval(myTimeDisplay)
    var myTimeDisplay = setInterval(() => {
      this.getNowTime()
    }, 1000)
    this.init()
  },
  data() {
    return {
      nowTimeDay: '',
      nowTimeSecond: '',
      headerBtn: '',//一级路由
      isFullscreen:false,
      currentPark:{},
      parkList:[],
      parkId: ''
    }

  },
  destroy () {
    if (screenfull.isEnabled) {
      screenfull.off('change', this.fullChange)
    }
  },
  created() {
    this.parkList = this.permissions.yqfx
    this.currentPark = this.current_site || {}
    if(this.$route.query && this.$route.query.parkId){
      //query 入参id 指定园区
      this.parkId = this.$route.query.parkId
      if(this.currentPark.id !== this.parkId){
        this.currentPark = this.parkList.find(v => {
          return v.id === this.parkId
        })
        this.$store.commit('SET_CURRENT_SITE',this.currentPark)
        this.$router.push({path:'/park'})

      }
    }else{
      this.parkId = this.currentPark.id
    }
  },
  methods: {
    setCurrentPark(){
      this.currentPark = this.parkList.find(v => {
        return v.id === this.parkId
      })
      this.$store.commit('SET_CURRENT_SITE',this.currentPark)
      this.reload()

    },
    getNowTime() {
      var date = new Date()
      let days = ['一', '二', '三', '四', '五', '六', '日']
      var nowTimeDay = date.getFullYear() + '/' + this.addZero(date.getMonth() + 1) + '/'
        + this.addZero(date.getDate()) + ' 周' + (date.getDay()==0?'日':days[date.getDay() - 1])
      var nowTimeSecond = this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes()) + ':'
        + this.addZero(date.getSeconds())
      this.nowTimeDay = nowTimeDay
      this.nowTimeSecond = nowTimeSecond
    },
    addZero(s) {
      return s < 10 ? ('0' + s) : s
    },
    goto(path) {
      this.$router.push({
        path
      })
    },
    //退出登录
    logout() {
      this.$cookies.remove('token')
      localStorage.removeItem(storePersistKey)
      this.$store.dispatch('userStore/clearToken')
      successToast("退出登录成功")
      this.$router.push({path: '/'})
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.fullChange)
      }
    },
    fullChange () {
      console.log(1111111,screenfull.isFullscreen)
      this.isFullscreen = screenfull.isFullscreen
    },
    //切换
    fullScreen () {
      if (!screenfull.isEnabled) {
        return false
      }
      //全屏
      screenfull.toggle();
    },
  }
}

</script>

<style scoped lang="scss">
.h-bg {
  height: 112px;
  width: 100%;
  background: url(~@/assets/images/header/h-bg.png) center/cover;

  .header-box {
    @include flex(space-around);
    height: 80px;

    .header-box-left,.header-box-right{
      width: 580px;
      @include flex(flex-start);
    }
    .btn-item {
      width: 120px;
      height: 34px;

      &.active {
        color: $mainColor-active;
        border-color: $mainColor-active;
        font-weight: bold;
        box-shadow: inset 0px 0px 10px 0px rgba(248, 197, 100, .7);
      }
    }

    .fullbtn {
      @include flex();
      color: #23E9FD;
      cursor: pointer;
      font-size: 16px;
      margin-left: auto;

      img {
        height: 32px;
        width: 32px;
        margin-right: 8px
      }
    }

    .top-time {
      @include flex();
      color: #23E9FD;
      flex-shrink: 0;
      margin-right: auto;
    }
    .top-btn{
      margin: 0 8px;
    }
    .title {
      flex-shrink: 0;
      height: 40px;
      font-family: AliHeavy;
      color: rgba(0, 0, 0, 0.65);
      line-height: 40px;
      //text-shadow: 0px 0px 16px rgba(0, 150, 255, 0.7), 0px 2px 2px rgba(0, 0, 0, 0.8);
      background: linear-gradient(360deg, #008CDC 0%, #02FEFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
/deep/ .el-input__inner {
    height: 34px;
    line-height: 34px;
  }

/deep/ .el-input__icon {
    height: 34px;
    line-height: 34px;
  }

</style>



// WEBPACK FOOTER //
// src/layoutPark/components/header.vue